const React = require('react');
import {Box} from "@material-ui/core";

import {
  account$
} from "../../../../../../emitters/account";
import {
  settings$,
  loadingSettings$,
  settingsUpdate,
  disableTfa,
} from "../../../../../../emitters/settings";
import withState from "../../../../../../utils/withState";

import WrapperWithLoading from "../../../../../dumb/WrapperWithLoading/B";
import {BtnBlueFilled} from "../../../../../helpers/Buttons";

import openPopupSetUpTfa from "./openPopupSetUpTfa";
import openPopupDisableTfa from "./openPopupDisableTfa";

module.exports = withState(() => {
  return (state, props) => {
    const account = state.account || {};
    const settings = state.settings || {};

    const btnProps = settings.need_tfa
      ? {
        onClick: () => {
          openPopupDisableTfa({}, () => {
            disableTfa({
              ...settings,
              need_tfa: false,
              fiat: account.fiat_code,
            });
          });
        },
        children: 'Disable 2FA'
      } : {
        onClick: () => {
          openPopupSetUpTfa({}, settingsUpdate);
        },
        children: 'Set Up 2FA'
      }

    return (
      <WrapperWithLoading
        className={props.className || ''}
        loading={state.loadingSettings}
      >
        <Box maxWidth="27rem" mt="3.5rem">
          <BtnBlueFilled {...btnProps} />
        </Box>
      </WrapperWithLoading>
    );
  };
}, {
  account: account$,
  settings: settings$,
  loadingSettings: loadingSettings$,
});
